/**
 * Module learning related routes
 */

import useSessionStore from '@/stores/session';
import RouterUtils from '@/utils/router';
import ModuleList from '@/views/learning/ModuleList.vue';
import SectorList from '@/views/learning/SectorList.vue';
import ThemeDetails from '@/views/learning/ThemeDetails.vue';
import ThemeList from '@/views/learning/ThemeList.vue';
import TopicList from '@/views/learning/TopicList.vue';

export default [
  {
    /** Sector list page */
    path: '/sectors/l/:learningTypeId',
    name: 'sectorList',
    component: SectorList,
    beforeEnter: [
      RouterUtils.checkLoginUser,
      RouterUtils.checkRunningModule,
      RouterUtils.resetHUBSettings,
      RouterUtils.checkLearningType,
      () => {
        RouterUtils.markLevelUp({ name: 'dashboard' });
      },
    ],
    props: true,
  },
  {
    /** Theme list page */
    path: '/themes/s/:sectorId',
    name: 'themeList',
    component: ThemeList,
    beforeEnter: [
      RouterUtils.checkLoginUser,
      RouterUtils.checkRunningModule,
      RouterUtils.resetHUBSettings,
      RouterUtils.checkLearningType,
      () => {
        RouterUtils.markLevelUp({
          name: 'sectorList',
          params: { learningTypeId: useSessionStore().HUBSettings.currentLearningType.id },
        });
      },
    ],
    props: true,
  },
  {
    /** Theme details page */
    path: '/theme/:themeId',
    name: 'themeDetails',
    component: ThemeDetails,
    beforeEnter: [
      RouterUtils.checkLoginUser,
      RouterUtils.checkRunningModule,
      RouterUtils.resetHUBSettings,
      RouterUtils.checkLearningType,
      RouterUtils.checkTheme,
      () => {
        RouterUtils.markLevelUp({
          name: 'themeList',
          params: { sectorId: useSessionStore().HUBSettings.currentTheme.sector_id },
        });
      },
    ],
    props: true,
  },
  {
    /** Topic list page */
    path: '/topics/th/:themeId',
    name: 'topicList',
    component: TopicList,
    beforeEnter: [
      RouterUtils.checkLoginUser,
      RouterUtils.checkRunningModule,
      RouterUtils.resetHUBSettings,
      RouterUtils.checkLearningType,
      RouterUtils.checkTheme,
      () => {
        RouterUtils.markLevelUp({
          name: 'themeDetails',
          params: { themeId: useSessionStore().HUBSettings.currentTheme.id },
        });
      },
    ],
    props: true,
  },
  {
    /** Module list page */
    path: '/modules/t/:topicId',
    name: 'moduleList',
    component: ModuleList,
    beforeEnter: [
      RouterUtils.checkLoginUser,
      RouterUtils.checkRunningModule,
      RouterUtils.resetHUBSettings,
      RouterUtils.checkLearningType,
      RouterUtils.checkTheme,
      () => {
        RouterUtils.markLevelUp({
          name: 'topicList',
          params: { themeId: useSessionStore().HUBSettings.currentTheme.id },
        });
      },
    ],
    props: true,
  },
];
